import React from "react";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../components/LanguageSwitcher";
import logoInstituto from "../assets/logo-instituto-negro.png";
import styles from "../styles/encuesta4c.module.css";

function EncuestaIndividualDesactivada() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <div className={`${styles.root} ${styles.layout}`}>
      <header className={styles.header}>
        <img src={logoInstituto} alt={t("common.logoAlt")} className={styles.logo} />
      </header>

      <main className={styles.main}>
        <div className={styles.welcomeWrap}>
          <h1 className={styles.welcomeTitle}>
            {t("form.title")}{" "}
            <span className={styles.welcomeTitleHighlight}>
              {t("form.titleHighlight")}
            </span>
          </h1>
          <div className={styles.invalidWrap}>
            <h2 className={styles.invalidTitle}>{t("disabled.title")}</h2>
            <p className={styles.invalidText}>{t("disabled.p1")}</p>
            <p className={styles.invalidText}>{t("disabled.p2")}</p>
          </div>
        </div>
      </main>

      <footer className={styles.footer}>{t("common.footer", { year })}</footer>
      <LanguageSwitcher />
    </div>
  );
}

export default EncuestaIndividualDesactivada;
